export default x=>()=>x;